import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebaseService';

export interface HtmlSanitizeMetrics {
  timeElapsedMs: number;
  originalCharCount: number;
  sanitizedCharCount: number;
  originalTokenCount: number;
  sanitizedTokenCount: number;
  contentReductionPercent: number;
  patternApplicationMetrics?: {
    patternsFound: number;
    htmlAfterPatterns: string;
    htmlAfterPatternsLength: number;
    patternReductionPercent: number;
  };
}

export interface HtmlSanitizeResult {
  success: boolean;
  sanitizedHtml: string;
  rawHtmlContent: string;
  metrics: HtmlSanitizeMetrics;
  error?: string;
}

/**
 * Calls the Cloud Function to sanitize HTML content from a URL
 * Now includes wrapper pattern application before sanitization!
 */
export const sanitizeHtmlFromURL = async (
  url: string,
  programName: string,
  locationId: string
): Promise<HtmlSanitizeResult> => {
  try {
    console.log(`[HTML Sanitize] Starting enhanced sanitization for program: ${programName} in location: ${locationId}`);
    console.log(`[HTML Sanitize] Calling Cloud Function with URL: ${url}`);

    // Initialize Firebase Functions with us-east4 region
    const functions = getFunctions(app, "us-east4");
    const sanitizeHtml = httpsCallable(functions, 'sanitizeHtmlFromURL');

    // Call the Cloud Function with the new interface
    const result = await sanitizeHtml({
      url,
      programName,
      locationId
    });

    const data = result.data as HtmlSanitizeResult;

    console.log(`[HTML Sanitize] Cloud Function response:`, data);

    if (data.success) {
      const metrics = data.metrics;
      console.log(`[HTML Sanitize] Enhanced sanitization successful!`, {
        originalChars: metrics.originalCharCount,
        sanitizedChars: metrics.sanitizedCharCount,
        totalReduction: `${metrics.contentReductionPercent.toFixed(1)}%`,
        patternsApplied: metrics.patternApplicationMetrics?.patternsFound || 0,
        patternReduction: metrics.patternApplicationMetrics ? 
          `${metrics.patternApplicationMetrics.patternReductionPercent.toFixed(1)}%` : 'N/A'
      });
      
      return {
        success: true,
        sanitizedHtml: data.sanitizedHtml,
        rawHtmlContent: data.rawHtmlContent,
        metrics: data.metrics
      };
    } else {
      return {
        success: false,
        sanitizedHtml: '',
        rawHtmlContent: data.rawHtmlContent || '',
        metrics: data.metrics,
        error: data.error || 'HTML sanitization failed'
      };
    }

  } catch (error) {
    console.error(`[HTML Sanitize] Error calling Cloud Function:`, error);
    return {
      success: false,
      sanitizedHtml: '',
      rawHtmlContent: '',
      metrics: {
        timeElapsedMs: 0,
        originalCharCount: 0,
        sanitizedCharCount: 0,
        originalTokenCount: 0,
        sanitizedTokenCount: 0,
        contentReductionPercent: 0
      },
      error: error instanceof Error ? error.message : 'Failed to sanitize HTML'
    };
  }
}; 